import { render } from "./ReportPagination.vue?vue&type=template&id=476a55ee&scoped=true"
import script from "./ReportPagination.vue?vue&type=script&lang=js"
export * from "./ReportPagination.vue?vue&type=script&lang=js"

import "./ReportPagination.vue?vue&type=style&index=0&id=476a55ee&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476a55ee"]])

export default __exports__